import { l1BlockExplorerUrl, l2BlockExplorerUrl } from "../utils";
import { CompactHash } from "./CompactHash";

export function TxHashLink({
  txHash,
  source,
}: {
  txHash: string;
  source: "l1" | "l2";
}) {
  const blockExplorerUrl = source === "l1" ? l1BlockExplorerUrl : l2BlockExplorerUrl;
  return (
    <CompactHash
      hash={txHash}
      href={blockExplorerUrl(txHash)}
      isExternal
      showAnchorIcon
    />
  );
}
